import { contractorDetailsStore } from '@/app/features/contractors/features/contractor-details/contractor-details.store';
import { contractorsListingStore } from '@/app/features/contractors/features/contractors-listing/contractors-listing.store';
import { newContractorStore } from '@/app/features/contractors/features/new-contractor/new-contractor.store';
export const contractorsStore = {
  modules: {
    contractorDetailsState: contractorDetailsStore,
    contractorLiistingsState: contractorsListingStore,
    newContractorState: newContractorStore
  }
};
